import React, { useEffect } from "react";

/**
 * Lightweight SEO component that sets document.title and meta tags imperatively.
 * Falls back to default site values on unmount.
 */
export default function Seo({ title, description, image, url }) {
  useEffect(() => {
    const defaults = {
      title: "MindDhara, Become Your Own Brain-Manager",
      description: "Mental health, cognitive support and psychology mentorship. Own Your Mind → Lead Yourself → Take Control.",
      image: `${window.location.origin}/logo.png`,
    };
    const finalTitle = title ? `${title} · MindDhara` : defaults.title;
    const finalDesc = description || defaults.description;
    const rawImage = image || defaults.image;
    const finalImage = rawImage.startsWith("http") ? rawImage : `${window.location.origin}${rawImage}`;
    const finalUrl = url || window.location.href;

    document.title = finalTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = selector.replace(/[\[\]"]/g, "").split("=");
        el.setAttribute(k, v);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", finalDesc);
    setMeta('meta[property="og:title"]', "content", finalTitle);
    setMeta('meta[property="og:description"]', "content", finalDesc);
    setMeta('meta[property="og:image"]', "content", finalImage);
    setMeta('meta[property="og:url"]', "content", finalUrl);
    setMeta('meta[name="twitter:title"]', "content", finalTitle);
    setMeta('meta[name="twitter:description"]', "content", finalDesc);
    setMeta('meta[name="twitter:image"]', "content", finalImage);
  }, [title, description, image, url]);

  return null;
}
